const SHIPPERORDERS_FETCH = 'shipperorders_fetch';
const SHIPPERORDER_CREATE = 'shipperorder_create';
const SHIPPERORDER_UPDATE = 'shipperorder_update';
const SHIPPERORDER_PRICE = 'shipperorder_price';

const JOURNEY_LAUNCH = 'journey_launch';
const JOURNEY_UNASSIGN = 'journey_unassign';
const JOURNEY_COST = 'journey_cost';
const JOURNEY_ADVANCE = 'journey_advance';

const HANDLING_NOT_ALLOWED = 'handling_not_allowed';

const HANDLING_NOT_ALLOWED_ERROR_RESPONSES = [
  'ShipperOrder for trailer cannot require handling',
  'ShipperOrder for TRAILER cannot require handling',
  'ShipperOrder for heavy_rigid_truck cannot require handling',
  'ShipperOrder for HEAVY_RIGID_TRUCK cannot require handling',
];

const DISPLAY_400_ERRORS_ACTIONS = [SHIPPERORDER_UPDATE, SHIPPERORDER_CREATE, HANDLING_NOT_ALLOWED];

export {
  SHIPPERORDERS_FETCH,
  SHIPPERORDER_CREATE,
  SHIPPERORDER_UPDATE,
  SHIPPERORDER_PRICE,
  JOURNEY_LAUNCH,
  JOURNEY_UNASSIGN,
  JOURNEY_COST,
  JOURNEY_ADVANCE,
  HANDLING_NOT_ALLOWED,
  HANDLING_NOT_ALLOWED_ERROR_RESPONSES,
  DISPLAY_400_ERRORS_ACTIONS,
};
